import {
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
  Stack,
} from "@mui/material";
import Modal from "components/modal/Modal";
import ModalSubmitFooter from "components/modal/ModalSubmitFooter";
import { CALL_FLOW_STATUS_OPTIONS } from "constant";
import { useState } from "react";
import { useUpdateStatusCallFlow } from "service/query/call-flow.query";

const CallFlowChangeStatusModal = ({ open, onClose, currentItem }) => {
  const [statusCurrent, setStatusCurrent] = useState(
    currentItem?.status ?? null
  );

  const updateStatusCallFlowQuery = useUpdateStatusCallFlow(currentItem?.id);
  const handleChangeStatus = (event) => {
    setStatusCurrent(event.target.value);
  };
  const handleSubmit = (event) => {
    event.preventDefault();
    let data = {
      status: statusCurrent,
    };
    updateStatusCallFlowQuery.mutate(
      {
        ...data,
      },
      {
        onSuccess: onClose(),
      }
    );
  };
  return (
    <Modal
      open={open}
      title="Cập nhật trạng thái"
      onClose={onClose}
      maxWidth="md">
      <form onSubmit={handleSubmit}>
        <Stack spacing={2}>
          <FormControl>
            <FormLabel id="radio-buttons-group">
              Trạng thái {currentItem?.callFlowId}
            </FormLabel>
            <RadioGroup
              aria-labelledby="radio-buttons-group"
              name="status-history"
              value={statusCurrent}
              onChange={handleChangeStatus}>
              {CALL_FLOW_STATUS_OPTIONS.map((statusItem) => (
                <FormControlLabel
                  key={statusItem.value}
                  value={statusItem.value}
                  control={<Radio />}
                  label={statusItem.label}
                />
              ))}
            </RadioGroup>
          </FormControl>
        </Stack>
        <ModalSubmitFooter
          onCancel={onClose}
          loading={updateStatusCallFlowQuery.isLoading}
        />
      </form>
    </Modal>
  );
};

export default CallFlowChangeStatusModal;
